export class ReqSystemPrompt { 
    constructor({pageId, promptText, creatAccountId, creatAt}) {
        this.pageId = pageId
        this.promptText = promptText
        if(creatAccountId !== undefined)
            this.creatAccountId = creatAccountId
        if(creatAt !== undefined)
            this.creatAt = creatAt
    }

    fromJson(jsonDate) {
        this.pageId = jsonDate.pageId
        this.promptText = jsonDate.promptText
        this.creatAccountId = jsonDate.creatAccountId
        this.creatAt = jsonDate.creatAt
    }

    toString() {
        return 'Name: '+this.fullName+', Age:'+this.age
    }
}

export class ReqSystemRecode { 
    constructor({pageId, action, creatAccountId, creatAt}) {
        this.pageId = pageId
        this.action = action
        if(creatAccountId !== undefined)
            this.creatAccountId = creatAccountId
        if(creatAt !== undefined)
            this.creatAt = creatAt
    }

    fromJson(jsonDate) {
        this.pageId = jsonDate.pageId
        this.action = jsonDate.action
        this.creatAccountId = jsonDate.creatAccountId
        this.creatAt = jsonDate.creatAt
    }

    toString() {
        return 'Name: '+this.fullName+', Age:'+this.age
    }
}
